// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r7-c";
export var backButton = "_r7-4";
export var backIcon = "_r7-5";
export var chevronShortcut = "_r7-6";
export var container = "_r7-1";
export var editor = "_r7-8";
export var editorWrapper = "_r7-7";
export var prefix = "_r7-2";
export var searchIcon = "_r7-3";
export var suffix = "_r7-9";
export var suffixContent = "_r7-a";
export var suffixText = "_r7-b";
export var wrapper = "_r7-0";